import type { Cells, CustomerData, CustomerResponseData } from '../types';

/*
 * For use in API calls using cell.appUrl to construct an absolute URL
 * within core-prod
 */
export const updateCellAppUrlForMultiTLDEnvs = (cells: Cells, envName: string) => {
  const cellName = envName.replace('kube', '');
  if (cells[cellName] && cells[cellName].appUrl !== window.location.origin) {
    cells[cellName].appUrl = window.location.origin;
  }

  return cells;
};

export const formatCustomerData = (
  customerData: CustomerResponseData[],
  cellData: Cells,
): CustomerData[] => customerData.map(v => ({
  ...v,
  organization_name: v.organization_name,
  organization_name_slug: v.organization_name_slug,
  description: v.description,
  parent_organization_slug: v.parent_organization_slug,
  parent_organization_slugs: v.parent_organization_slugs,
  cell: cellData[v.cell]?.displayName ?? v.cell,
  cellKey: v.cell,
  joined: v.joined
    ? new Date(v.joined).toLocaleDateString('en-us', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
    : '',
}));

export const formatCellData = (obj: Cells) => Object.entries(obj)
  .map(([cellKey, cellConfig]) => ({
    label: cellConfig.displayName,
    value: cellKey,
  }));
